import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import Chart from 'chart.js/auto';
import Annotation from 'chartjs-plugin-annotation';

Chart.register(Annotation);

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
